import React, { useState } from 'react';
import { slideValidation, dobValidation, numberValidation } from '../../../../Utility/Validations';
import SelectBox from '../../../UI/SelectBox';
import { DobYear, DobMonth, DobDay } from '../../../../Constants/Constants';
import GTMDataLayer from '../../../../Utility/GTMDataLayer';

const Dob = (props) => {
	const [valids, setValids] = useState('');
	const handleDateOfBirthSubmit = async (e) => {
		const validationArr = ['DobDay', 'DobMonth', 'DobYear'];
		const values = props.getValues();
		const validationCheck = await slideValidation(validationArr, props.trigger);
		if (validationCheck == 'Success') {
			var validDate = dobValidation(
				values.DobDay,
				values.DobMonth,
				values.DobYear
			);
			if (validDate == false) {
				setValids('Please enter a valid date');
			} else {
				setValids('');
				GTMDataLayer({
					clickEvent: 'slideclick',
					question: 'dob',
					answer: '',
				});
				props.slideChange(e);
			}
		}
	};
	return (
		<div className={props.slideStatus}>
			<label class="mt-3 mb-3" style={{fontSize:"18px",textAlign:"center"}} htmlFor="Date of Birt">Enter Your Date of Birth to See If You Qualify</label>			
			<div className="d-flex gap-2 dobmobile">
				<div className='mb-2'>

					<SelectBox
						name="DobDay"
						id="DobDay"
						OptionValue={DobDay}
						className="p-day w-100 form-select text-center"
						register={props.register('DobDay', {
							required: 'Please Type Date',
							pattern: {
								value: /^(0?[1-9]|[12][0-9]|3[01])$/,
								message: 'Enter Valid Day.',
							},
						})}
						validationMsg={
							props.validationMsg.DobDay && props.validationMsg.DobDay.message
						}
						onChange={() => {
							props.clearErrors(`DobDay`);
						}}
					/>
				</div>
				<div className='mb-2'>

					<SelectBox
						name="DobMonth"
						id="DobMonth"
						className="p-day w-100 form-select text-center"
						OptionValue={DobMonth}
						register={props.register('DobMonth', {
							required: 'Please Type Month',
							pattern: {
								value: /^(January|February|March|April|May|June|July|August|September|October|November|December)$/,
								message: 'Enter valid Month.',
							}
						})}
						validationMsg={
							props.validationMsg.DobMonth &&
							props.validationMsg.DobMonth.message
						}
						onChange={() => {
							props.clearErrors(`DobMonth`);
						}}

					/>
				</div>
				<div className='mb-2'>
					<SelectBox
						name="DobYear"
						id="DobYear"
						className="p-day w-100 form-select text-center"
						OptionValue={DobYear}
						register={props.register('DobYear', {
							required: 'Please Type Year',
							pattern: {
								value: /^(19[1-9][0-9]|200[0-6])$/,
								message: 'Invalid Year.',
							}
						})}
						validationMsg={
							props.validationMsg.DobYear &&
							props.validationMsg.DobYear.message
						}
						onChange={() => {
							props.clearErrors(`DobYear`);
						}}

					/>
				</div>
						
			</div>
			<div className="row">
				{valids && (
						<div className="error_msg">
							<span>{valids}</span>
						</div>
					)}
			</div>

			<button type="button" name="next1" onClick={handleDateOfBirthSubmit} className="next-btn">Next</button>
		</div>
	);
};

export default Dob;
